__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/bef8edd26765dc4196fe18bb635c7b4046da0c711c07a48847fe7879/";